import type { AdminExperience } from "@/types/admin";
import { getLabel, getEmoji } from "@/utils/taxonomy";
import { WHAT_HAPPENED, FEELINGS } from "@/shared/taxonomy";

const statusColors: Record<string, string> = {
  APPROVED: "bg-primary-container text-on-primary-container",
  REJECTED: "bg-error-container text-on-error-container",
  NEEDS_HUMAN_REVIEW: "bg-secondary-container text-on-secondary-container",
  PENDING: "bg-surface-container-high text-on-surface",
};

export function AdminExperienceCard({ experience }: { experience: AdminExperience }) {
  return (
    <div className="bg-surface-container-lowest border border-white/5 rounded-xl p-stack-md">
      <div className="flex items-start justify-between gap-stack-md mb-2">
        <div className="flex flex-wrap gap-1.5">
          {experience.whatHappened.map((id) => (
            <span
              key={id}
              className="inline-flex items-center gap-1 px-2 py-0.5 bg-surface-container-high rounded-full font-label-xs text-label-xs text-on-surface"
            >
              {getEmoji(WHAT_HAPPENED, id as (typeof WHAT_HAPPENED)[number]["id"])} {getLabel(WHAT_HAPPENED, id as (typeof WHAT_HAPPENED)[number]["id"])}
            </span>
          ))}
        </div>
        <span
          className={`px-2 py-0.5 rounded-full font-label-xs text-label-xs shrink-0 ${
            statusColors[experience.status] ?? "bg-surface-container-high text-on-surface"
          }`}
        >
          {experience.status}
        </span>
      </div>

      {experience.context && (
        <p className="font-body-md text-body-md text-on-surface line-clamp-2 mb-2">
          &quot;{experience.context}&quot;
        </p>
      )}

      <div className="flex flex-wrap items-center gap-2 text-on-surface-variant">
        {experience.companyId && (
          <span className="font-label-xs text-label-xs">{experience.companyId}</span>
        )}
        {experience.function && (
          <span className="font-label-xs text-label-xs">· {experience.function}</span>
        )}
        {experience.seniority && (
          <span className="font-label-xs text-label-xs">· {experience.seniority}</span>
        )}
        {experience.feelings.length > 0 && (
          <span className="font-label-xs text-label-xs">
            · {experience.feelings.map((id) => getEmoji(FEELINGS, id as (typeof FEELINGS)[number]["id"])).filter(Boolean).join(" ")}
          </span>
        )}
        <span className="font-label-xs text-label-xs ml-auto">
          {new Date(experience.createdAt).toLocaleDateString()}
        </span>
      </div>
    </div>
  );
}
